module.exports = __webpack_public_path__ + "static/media/guia.e4413fc4.jpg";